(() => {
  const theme = window.JataraoTheme || {};

  const formatMoney = (cents) => {
    const amount = Number(cents || 0) / 100;
    try {
      return new Intl.NumberFormat(theme.locale || 'en-IN', {
        style: 'currency',
        currency: theme.currency || 'INR',
        currencyDisplay: theme.moneyWithCurrency ? 'code' : 'symbol',
        maximumFractionDigits: amount % 1 === 0 ? 0 : 2
      }).format(amount);
    } catch (_error) {
      return `₹${amount.toFixed(2)}`;
    }
  };

  document.querySelectorAll('[data-product-root]').forEach((root) => {
    const dataNode = root.querySelector('[data-product-variants]');
    if (!dataNode) return;

    let variants = [];
    try {
      variants = JSON.parse(dataNode.textContent);
    } catch (_error) {
      return;
    }

    const selectors = [...root.querySelectorAll('[data-option-position]')];
    const idInput = root.querySelector('input[name="id"]');
    const price = root.querySelector('[data-product-price]');
    const comparePrice = root.querySelector('[data-product-compare-price]');
    const addButton = root.querySelector('[data-add-to-cart]');
    const availability = root.querySelector('[data-product-availability]');

    const update = () => {
      const selectedOptions = selectors.map((selector) => selector.value);
      const variant = variants.find((candidate) => candidate.options.every((option, index) => option === selectedOptions[index]));

      if (!variant) {
        if (idInput) idInput.value = '';
        if (addButton) {
          addButton.disabled = true;
          addButton.textContent = theme.strings?.unavailable || 'Unavailable';
        }
        if (availability) {
          availability.textContent = theme.strings?.unavailable || 'Unavailable';
          availability.classList.add('is-unavailable');
        }
        return;
      }

      if (idInput) idInput.value = variant.id;
      if (price) price.textContent = formatMoney(variant.price);
      if (comparePrice) {
        const onSale = Number(variant.compare_at_price || 0) > Number(variant.price || 0);
        comparePrice.textContent = onSale ? formatMoney(variant.compare_at_price) : '';
        comparePrice.classList.toggle('is-hidden', !onSale);
      }
      if (addButton) {
        addButton.disabled = !variant.available;
        addButton.textContent = variant.available
          ? (theme.strings?.addToCart || 'Add to cart')
          : (theme.strings?.soldOut || 'Sold out');
      }
      if (availability) {
        availability.textContent = variant.available
          ? availability.dataset.inStock
          : availability.dataset.soldOut;
        availability.classList.toggle('is-unavailable', !variant.available);
      }

      if (variant.featured_media?.id) {
        root.querySelector(`[data-media-id="${variant.featured_media.id}"]`)?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
      }

      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
      root.dispatchEvent(new CustomEvent('product:variant-change', { bubbles: true, detail: { variant } }));
    };

    selectors.forEach((selector) => selector.addEventListener('change', update));
  });
})();
